import { Grid, Tooltip } from '@material-ui/core';
import { Warning } from '@material-ui/icons';
import React, { useMemo } from 'react';
import { useStyles } from './styles';
import { IQuestionItem, IQuestionType } from 'pages/formsCreate/types';

interface IProps {
  isError?: boolean;
  isWarn?: boolean;
  item: IQuestionItem<IQuestionType>;
}

export const QuestionWarning = ({ item, isWarn = false, isError = false }: IProps) => {
  const styles = useStyles();

  const warnMessage = useMemo(() => {
    const optionsLength = item.options.length;
    if (optionsLength === 0) return 'Não há opções para essa pergunta';
    if (optionsLength === 1) return 'Essa pergunta só possui uma opção';
    return '';
  }, [item.options]);

  if (!(isWarn || isError)) return null;
  return (
    <Grid item className={styles.warningContainer} data-error={isError} data-warn={isWarn}>
      <Tooltip title={warnMessage} placement="top" arrow>
        <Warning />
      </Tooltip>
    </Grid>
  );
};
